import { CBT_PROGRAMME_TYPE } from '@cont/SeeAll/constants';
import pushRoute from '@utils/pushRoute';

export const getIsCbtProgramme = (quizDetails) => {
  const programmeType = quizDetails?.collection?.programme?.programme_type;
  return programmeType === CBT_PROGRAMME_TYPE;
};

export const navigateToNtaInstructionsPage = ({
  pathname,
  quizUID,
  quizSlug
}) =>
  pushRoute(
    {
      pathname,
      query: {
        quizUID,
        quizSlug,
        show_instructions: true
      }
    },
    undefined,
    { shallow: true }
  );

export const generatePageDeepLinkForMobile = async () => {
  const defaultLink = `https://unacademy.com${window.location.pathname}`;

  return new Promise((resolve) => {
    if (window.branch && window.branch.init) {
      // In case of browsers such as Brave, certain tracking scripts and cookies are blocked, hence window.branch and window.branch.init will be undefined. In that case, just open the default URL.
      window.branch.init(process.env.BRANCH_IO_LIVE_KEY, {}, (err) => {
        if (err) {
          return resolve(defaultLink);
        }

        const data = {
          campaign: 'mweb',
          channel: 'mweb',
          feature: 'mweb',
          stage: 'new user',
          tags: [],
          alias: '',
          data: {
            deep_link_for_story_object: defaultLink,
            $desktop_url: defaultLink,
            $og_title: document.title
          }
        };

        const callback = (deepLinkGenerationError, link) => {
          if (deepLinkGenerationError) {
            return resolve(defaultLink);
          }

          return resolve(link);
        };

        const generatedDeepLink = window.branch.link(data, callback);

        return generatedDeepLink || defaultLink;
      });
    } else return resolve(defaultLink);
  });
};

const GEN_INSTRUCTIONS = '<p>General instructions</p>';

export const getIsGeneralInstructions = (instructions = '') => {
  return instructions === GEN_INSTRUCTIONS;
};
